import SetPasswordPage from "./SetPasswordPage";

export default SetPasswordPage;
